interface OptimizelyData {
    experiment_exposures: string | null;
    experiment_user_ID: string | null;
}

export const getOptimizelyData = (): OptimizelyData => {
    if (typeof window !== 'undefined') {
        const getCookie = (name: string): string | null => {
            const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
            return match ? decodeURIComponent(match[1]) : null;
        };

        return {
            experiment_exposures: getCookie('experiment_exposures'),
            experiment_user_ID: getCookie('optimizelyEndUserId'),
        };
    }
    return { experiment_exposures: null, experiment_user_ID: null };
};
